import React from "react";
import { Flex } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import bgImage from "../../../../public/assets/animations/splits-bg.png";
import { SplitsAnimation, borderSpacing } from "./splits";

export function SplitsAnimationWithBg({ delay = 1 }: { delay?: number }) {
  return (
    <Flex align="start" bg="new.blue.150" color="brand.text.light" boxSize="100%" p={borderSpacing} pos="relative">
      <DecorativeBackgroundImage priority src={bgImage} />

      <SplitsAnimation delay={delay} />
    </Flex>
  );
}
